// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"268":"e4c0749a","777":"34a3f4cc"}[chunkId] + ".chunk.css";
};